import { useState } from "react";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarBlank, X } from "@phosphor-icons/react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const DatePicker = ({ value, onChange, testId, placeholder = "Selecionar data", clearable = false, light = false, minDate }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;

  const trigger = light
    ? "w-full flex items-center gap-2 bg-white border border-slate-300 rounded px-2 py-2.5 sm:py-1.5 text-base sm:text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-800"
    : "flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded px-3 py-2.5 sm:py-2 text-base sm:text-sm text-zinc-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 hover:border-zinc-700 transition-colors";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className={trigger}>
          <CalendarBlank size={15} className={light ? "text-blue-950" : "text-zinc-500"} />
          <span className={date ? "" : light ? "text-slate-400" : "text-zinc-500"}>
            {date ? format(date, "dd/MM/yyyy") : placeholder}
          </span>
          {clearable && value && (
            <span
              data-testid={testId ? `${testId}-clear` : undefined}
              role="button"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className={`ml-1 ${light ? "text-slate-400 hover:text-slate-700" : "text-zinc-500 hover:text-zinc-200"} transition-colors`}
            >
              <X size={13} />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-zinc-900 border-zinc-800 text-zinc-50 z-[100]" align="start">
        <Calendar
          mode="single"
          locale={ptBR}
          selected={date}
          defaultMonth={date}
          disabled={minDate ? { before: parseISO(minDate) } : undefined}
          onSelect={(d) => { if (d) onChange(format(d, "yyyy-MM-dd")); setOpen(false); }}
        />
      </PopoverContent>
    </Popover>
  );
};
